import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import PropTypes from 'prop-types';

const CustomTooltip = ({ backgroundColor, children, ...props }) => {
    const StyledTooltip = styled(({ className, ...restProps }) => (
        <Tooltip {...restProps} arrow classes={{ popper: className }}>
            {children}
        </Tooltip>
    ))(() => ({
        [`& .${tooltipClasses.arrow}`]: { color: backgroundColor || 'rgba(0,0,0,0.85)' },
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: backgroundColor || 'rgba(0,0,0,0.85)',
            color: '#fff',
            fontWeight: 600,
            fontSize: '11px',
            padding: '5px 10px',
            borderRadius: '6px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
            border: '1px solid rgba(255, 255, 255, 0.1)',
        },
    }));

    return <StyledTooltip {...props} />;
};

CustomTooltip.propTypes = {
    backgroundColor: PropTypes.string,
    children: PropTypes.node,
};

export default CustomTooltip;
